<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_company</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-search title="会社"></title-and-search>
          <search-control 
          style="padding-bottom: 10px;"
          :field_names="allFields" @change="searchControlChangedDatasource"></search-control>
          <ag-grid-vue style="width: 100%; height: 325px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <br>
          <div style="float: left;;margin-top:5px">
            件数
            </div>
            <input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;float: left;margin-left:5px" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
          <div style="margin-top:5px;">
            <button
            :disabled="formExportFileDisabled || checkUserPermission(true,permissionMode.EXPORT) == false"
            class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;" @click="initExportFile" >出力</button>
            <button
            :disabled="selected_row == -1 || checkUserPermission(true,permissionMode.DELETE) == false"
            class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete">削除</button>
            <button
            :disabled="checkUserPermission(true,permissionMode.ADD) == false"
            class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #92D050;border-color:#92D050;" @click="addNew">新規</button>
            <file-download-modal tag="runDeviceEmbeddedInformationDownloadModal" @close="onCloseExportFile"/>
          </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_master_company';
import { utils } from '@/libs/utils';
import fileDownloadModal from '@/components/modals/file-download-modal';


import _debug from 'debug';
var mdebug = _debug('esma:master_user');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'ag-grid-vue': AgGridVue,
    'file-download-modal':fileDownloadModal
  },
  data() {
    return {
      api_name:"master_company",
      page_acl: acl.maintenance,
      detail_page:"page_0041_master_company_detail",
      execute_filter_on_back:true,
      link_to_open:"#"
    };
  },
  computed: {
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        utils.extend(fields.company_id, {}),
        utils.extend(fields.company_name, {}),
      ];
    },
    linkToOpen:{
      get(){
        return this.link_to_open;
      },
      set(v){
        this.link_to_open = v;
      }
    },
  },
  methods: {
    initExportFile(){
      //FILE_EXPORT_PART2 : Step 2
      bus.$emit("runDeviceEmbeddedInformationDownloadModal",{
        message: "ファイルを出力しています。",
        on_complete_message:"出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url:"/master_company/export_data/"
      });
    },
    onCloseExportFile(){},
    onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: {  seq_id:data.seq_id} });
    },
    addNew(){
      return this.$router.push({ name: this.detail_page, params: {  seq_id:"new"} });
    },
    onDelete(){
      if(this.selected_row > -1){
        return this.$router.push({ name: this.detail_page, params: {  seq_id:this.selected_row,cmd:"delete"} });
      }
    },
    onEdit(){
      return this.$router.push({ name: this.detail_page, params: {  seq_id:this.selected_row,cmd:"edit"} });
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:true})
    },
    onRowSelected(ev){
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.initDatasource();
  }
};

</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0041_master_company.vue?29ad71b0